export default __webpack_public_path__ + "static/media/ic_broadband_black.63bf1474.svg";